import React, {
  Fragment,
  useContext,
  useState,
  useEffect,
  useMemo,
  useRef,
} from "react";
import { useHistory, useParams, withRouter } from "react-router-dom";
import FhirReferralsList from "./FhirReferralsList";
import { enableServiceDirectory, referralsFormUUID } from "../../../utils/constants";
import styles from "../../../styles/viewer.module.css";
import { Context } from "../../../store/AppStore";
import {
  FhirReferralActions,
  FhirReferralActionButton,
} from "./FhirReferralActions";
import FhirReferralDialog from "./FhirReferralDialog";
import { ThemeProvider } from "@material-ui/core/styles";
import { theme } from "../theme";
import { Container } from "@material-ui/core";
import auth from "../../../utils/auth";
// import ServicesSelectionDialog from "./ServicesSelectionDialog";
import useReferrals from "./useReferrals";
import useOrganizations from "./useOrganizations";
import FhirServicesSelectionDialog from "./FhirServicesSelectionDialog";
import moment from "moment";
import { getUserOrgByName } from "./utils";
import { checkAclValidation } from "../../../utils/permissions/permission.utils";
import mainAcls from "../../../utils/permissions/mainAcls";
import { TenantConfigurationStore } from "../../Tenants/TenantConfigurationStore";
import FhirReferralAddForm from "./FhirReferralAddForm";
import { FhirReferralsAPI } from "../../../services";
import FormRendererAPI from "../../../services/FormRendererAPI";

const API = FhirReferralsAPI;

const FhirReferralsViewer = ({ showAllReferrals }) => {
  const history = useHistory();
  const [, dispatch] = useContext(Context);
  const { patientId } = useParams();
  const [referralDialogOpen, setReferralDialogOpen] = useState(false);
  const [referralAddFormOpen, setAddFormOpen] = useState(false);
  const [error, setError] = useState("");
  const [servicesSelectionDialogOpen, setServicesSelectionDialogOpen] =
    useState(false);

  // const [referralAddFormDataLoaded, setReferralAddFormDataLoaded] =
  //   useState(false);

  const [planDefinition, setPlanDefinition] = useState([]);

  const [requestIntentVS, setRequestIntentVS] = useState([]);
  const [requestIntentVSLoaded, setRequestIntentVSLoaded] = useState(false);

  const [requestCategoryVS, setRequestCategoryVS] = useState([]);
  const [requestCategoryVSLoaded, setRequestCategoryVSLoaded] = useState(false);

  const [referralServicesInternal, setReferralServicesInternal] = useState([]);
  const [referralServicesInternalLoaded, setReferralServicesInternalLoaded] =
    useState(false);

  const [referralPathCategory, setReferralPathCategory] = useState([]);
  const [referralPathCategoryLoaded, setReferralPathCategoryLoaded] =
    useState(false);

  const [healthcareServices, setHealthcareServices] = useState([]);
  const [healthcareServicesLoaded, setHealthcareServicesLoaded] =
    useState(false);

  const [submitError, setSubmitError] = useState(null);
  const [isReferralDocumentDialogOpen, setIsReferralDocumentDialogOpen] =
    useState(false);
  const [referralDialogSize, setReferralDialogSize] = useState(null);

  const [advancedPlanDefinitionIds, setAdvancedPlanDefinitionIds] = useState([]);
  const [hasLoadedAdvancedPlanDefinitions, setHasLoadedAdvancedPlanDefinitions] = useState(false);
  const [hasLoadedFormSize, setHasLoadedFormSize] = useState(false);

  const [instantiatesCanonical, setInstantiatesCanonical] = useState(null);

  const {
    referrals,
    serviceCategories,
    patient,
    createReferral,
    error: referralsError,
  } = useReferrals({
    patientId,
    showAllReferrals,
    // referralQuery: { "category:not": "advanced-referral" },
  });

  const { organizations: availableOrganizations, error: organizationsError } =
    useOrganizations({});

  useEffect(() => {
    console.log("DEBUG useEffect availableOrganizations: ", availableOrganizations);
  }, [availableOrganizations])


  const handleGetValueSets = async () => {
    const requestIntentVSResult = await API.getValueSet("request-intent");
    if (requestIntentVSResult) {
      setRequestIntentVS(requestIntentVSResult);
      setRequestIntentVSLoaded(true);
    }

    const requestCategoryVSResult = await API.getValueSet(
      "ph-request-category"
    );
    if (requestCategoryVSResult) {
      setRequestCategoryVS(requestCategoryVSResult);
      setRequestCategoryVSLoaded(true);
    }

    const referralServicesInternalResult = await API.getValueSet(
      "ph-referral-services-internal"
    );
    if (referralServicesInternalResult) {
      setReferralServicesInternal(referralServicesInternalResult);
      setReferralServicesInternalLoaded(true);
    }

    const referralPathCategoryResult = await API.getValueSet(
      "ph-service-request-path-category"
    );
    if (referralPathCategoryResult) {
      setReferralPathCategory(referralPathCategoryResult);
      setReferralPathCategoryLoaded(true);
    }
  };

  const handleGetPlanDefinition = async () => {
    const result = await API.getPlanDefinition(
      requestIntentVS,
      referralServicesInternal
    );
    if (result) {
      setPlanDefinition(result);
    }
  };

  const handleGetHealthcareServices = async () => {
    setHealthcareServicesLoaded(false);
    let healthCareServiceFilters = {};
    const services = await API.getHealthcareServices(healthCareServiceFilters);
    if (services) {
      setHealthcareServices(services);
    }
    setHealthcareServicesLoaded(true);
  };

  useEffect(() => {
    if (requestIntentVSLoaded && referralServicesInternalLoaded) {
      handleGetPlanDefinition();
    }
  }, [
    requestIntentVS,
    referralServicesInternal,
    requestIntentVSLoaded,
    referralServicesInternalLoaded,
  ]);

  useEffect(() => {
    handleGetValueSets();
    handleGetHealthcareServices();
  }, []);

  const hasLoadedReferralAddFormData = useMemo(() => {
    return (
      requestIntentVSLoaded &&
      referralServicesInternalLoaded &&
      requestCategoryVSLoaded &&
      referralPathCategoryLoaded
    );
  }, [
    requestIntentVSLoaded,
    referralServicesInternalLoaded,
    requestCategoryVSLoaded,
    referralPathCategoryLoaded,
  ]);

  const handleReferralClick = (referral) => {
    if (referral) {
      dispatch({ type: "UPDATE_REFERRAL", payload: referral });
      if (showAllReferrals) {
        const subjectId = referral?.subject?.reference?.split("/")?.[1];
        if (subjectId) {
          history.push(
            `/patient/search/${subjectId}/info/1/referrals/${referral.id}`
          );
        }
        // history.push(`/referrals/${referral.id}`);
      } else {
        history.push(
          `/patient/search/${patientId}/info/1/referrals/${referral.id}`
        );
      }
    }
  };

  const getAdvancedPlanDefinitions = async () => {
    try {
      const tenantData =
        await TenantConfigurationStore.getTenantConfiguration(true);
      const advanced = tenantData?.referral?.referralAdvancedPlanDefinitions ?? [];
      setAdvancedPlanDefinitionIds(advanced);
    } catch (error) {
      console.log(error)
    }

    setHasLoadedAdvancedPlanDefinitions(true);
  }

  const getFormRendererSize = async (selectedReferral) => {
    const result = await FormRendererAPI.getReferralFormSize(
      referralsFormUUID
    );

    if (result && result?.width && result?.height) {
      setReferralDialogSize(result);
    }

    setHasLoadedFormSize(true);

  }

  useEffect(() => {
    getAdvancedPlanDefinitions()
    getFormRendererSize()
  }, [])

  const handleNewReferralClick = () => {
    setReferralDialogOpen(true);
  };

  const handleReferralDialogClosed = () => {
    setReferralDialogOpen(false);
  };

  const handleServicesSelectionDialogClick = () => {
    setServicesSelectionDialogOpen(true);
  };

  const handleServicesSelectionDialogClosed = () => {
    setServicesSelectionDialogOpen(false);
  };

  const handleReferralAddFormClick = () => {
    setAddFormOpen(true);
  };

  const handleReferralAddFormClose = () => {
    setAddFormOpen(false);
  };

  const saveFormResponse = async (
    formResponse,
    relatedPatientId,
    referralId
  ) => {
    console.log("DEBUG saveFormResponse relatedPatientId: ", relatedPatientId);
    console.log("DEBUG saveFormResponse referralId: ", referralId);

    const base64FormResponse = btoa(JSON.stringify(formResponse));

    const binaryPayload = {
      contentType: "application/json",
      data: base64FormResponse,
      resourceType: "Binary",
    };

    const createdBinary = await FhirReferralsAPI.createBinary(binaryPayload);

    console.log("DEBUG createdBinary: ", createdBinary);

    if (!createdBinary?.id) return null;

    const currentDate = new Date().toISOString();

    const patientReference = `Patient/${relatedPatientId}`;

    const documentReferencePayload = {
      content: [
        {
          attachment: {
            contentType: `${createdBinary?.contentType}`,
            creation: currentDate,
            title: `AssessmentResponse_${currentDate}`,
            url: `${process.env.REACT_APP_FHIR_BASE_URL}/Binary/${createdBinary?.id}`,
          },
        },
      ],
      masterIdentifier: {
        use: "official",
        value: "value document",
      },
      resourceType: "DocumentReference",
      status: "current",
      subject: {
        reference: `Patient/${relatedPatientId}`,
      },
      context: {
        sourcePatientInfo: {
          reference: patientReference,
          type: "Patient",
        },
        related: [
          {
            reference: `ServiceRequest/${referralId}`,
            type: "ServiceRequest",
          },
        ],
      },
    };

    const createdDocumentReference =
      await FhirReferralsAPI.createDocumentReference(documentReferencePayload);

    console.log("DEBUG createdDocumentReference: ", createdDocumentReference);

    if (!createdDocumentReference?.id) return null;

    return createdDocumentReference;
  };

  const handleReferralSave = async (referralData, formResponse = null, linkedDocuments = []) => {
    console.log("DEBUG handleReferralSave referralData: ", referralData);
    console.log("DEBUG user: ", auth.user());
    console.log("DEBUG patient: ", patient);

    const { instantiatesCanonical, intent, service } = referralData;

    console.log("DEBUG handleReferralSave availableOrganizations: ", availableOrganizations);
    console.log("DEBUG handleReferralSave userinfo.orgName: ", auth.user().userinfo.orgName);

    const userOrganization = getUserOrgByName(
      auth.user().userinfo.orgName,
      availableOrganizations
    );

    console.log("DEBUG handleReferralSave userOrganization: ", userOrganization);


    if (!userOrganization) {
      setError(
        `Organization with name ${auth.user().userinfo.orgName} does not exist`
      );
      return "";
    }

    if (!patient) {
      console.log("DEBUG: patient not defined");
      return "";
    }

    try {
      const tenantConf =
        await TenantConfigurationStore.getTenantConfiguration();
      const fhirBaseUrl = tenantConf?.fhir?.fhirBaseUrl;

      const performer = service?.value?.organization;
      console.log("DEBUG performer: ", performer);

      const payload = {
        resourceType: "ServiceRequest",
        instantiatesCanonical: [instantiatesCanonical?.reference],
        category: [
          {
            coding: [
              {
                code: "internal-referral",
                display: "Internal Referral",
                system: `${fhirBaseUrl}/CodeSystem/ph-pw-service-request-category`,
              },
            ],
            text: "Internal Referral",
          },
        ],
        code: {
          coding: [
            {
              code: "internal-referral",
              display: "Internal Referral",
              system: `${fhirBaseUrl}/CodeSystem/ph-pw-service-request-type`,
            },
          ],
          text: "Internal Referral",
        },
        subject: {
          reference: `Patient/${patient.id}`,
        },
        requester: {
          reference: `Organization/${userOrganization.id}`,
          display: userOrganization.name,
        },
        ...(performer && {
          performer: [
            {
              reference: `Organization/${performer.id}`,
              display: performer.name,
            },
          ]
        }),
        status: "active",
        intent: intent?.code ? intent.code : "plan",
        priority: referralData?.urgent ? "urgent" : "routine",
        // note: [
        //   {
        //     text: referralData?.description,
        //   },
        // ],
        occurrenceDateTime: moment().toISOString(),
      };
      console.log("DEBUG payload: ", payload);

      const createdReferral = await createReferral(payload);
      console.log("DEBUG created referral: ", createdReferral);

      if (formResponse && createdReferral) {
        const savedResponse = await saveFormResponse(
          formResponse,
          patientId,
          createdReferral?.id
        );
      }

      handleReferralAddFormClose();
      
      return "";
    } catch (error) {
      return error.message;
    }
  };

  const handleAdvancedReferralSave = async (formEvent) => {
    console.log("DEBUG handleAdvancedReferralSave formEvent: ", formEvent);

    const formResponse =
      formEvent?.type === "form-submitted" && formEvent?.payload
        ? formEvent.payload
        : null;

    console.log("DEBUG handleAdvancedReferralSave formResponse: ", formResponse);

    if (!formResponse) {
      return;
    }

    const linkedDocuments = formResponse["linked_documents"];
    if (linkedDocuments) {
      delete formResponse["linked_documents"];
    }

    const referralData = { instantiatesCanonical: instantiatesCanonical }

    handleReferralSave(referralData, formResponse, linkedDocuments);

  };

  const handleAdvancedReferralSaveRef = useRef();
  handleAdvancedReferralSaveRef.current = handleAdvancedReferralSave;

  const messageListener = useRef(async (event) => {
    // console.log("DEBUG FhirReferralsViewer messageListener event: ", event);
    const formEvent = event.data;
    if (formEvent.type === "form-submitted") {
      await handleAdvancedReferralSaveRef.current(formEvent);
    }
    if (formEvent.type === "link-documents") {
      setIsReferralDocumentDialogOpen(true);
    }
  });

  useEffect(() => {
    const listener = messageListener.current;

    if (referralDialogSize) {
      window.addEventListener("message", listener);
    }

    return () => {
      window.removeEventListener("message", listener);
    };
  }, [referralDialogSize]);

  const handleReferralSaveLegacy = async (referralData) => {
    console.log("DEBUG handleReferralSave referralData: ", referralData);
    console.log("DEBUG user: ", auth.user());
    console.log("DEBUG patient: ", patient);
    const userOrganization = getUserOrgByName(
      auth.user().userinfo.orgName,
      availableOrganizations
    );
    if (!userOrganization) {
      setError(
        `Organization with name ${auth.user().userinfo.orgName} does not exist`
      );
      return "";
    }

    if (!patient) {
      console.log("DEBUG: patient not defined");
      return "";
    }

    try {
      const tenantConf =
        await TenantConfigurationStore.getTenantConfiguration();
      const fhirBaseUrl = tenantConf?.fhir?.fhirBaseUrl;

      const performer = referralData?.receivingOrganization;
      console.log("DEBUG performer: ", performer);

      const payload = {
        resourceType: "ServiceRequest",
        category: [
          {
            coding: [
              {
                code: "internal-referral",
                display: "Internal Referral",
                system: `${fhirBaseUrl}/CodeSystem/ph-pw-service-request-category`,
              },
            ],
            text: "Internal Referral",
          },
        ],
        code: {
          coding: [
            {
              code: "internal-referral",
              display: "Internal Referral",
              system: `${fhirBaseUrl}/CodeSystem/ph-pw-service-request-type`,
            },
          ],
          text: "Internal Referral",
        },
        subject: {
          reference: `Patient/${patient.id}`,
        },
        requester: {
          reference: `Organization/${userOrganization.id}`,
          display: userOrganization.name,
        },
        performer: [
          {
            reference: `Organization/${performer.id}`,
            display: performer.name,
          },
        ],
        status: "active",
        intent: "plan",
        priority: referralData?.urgent ? "urgent" : "routine",
        note: [
          {
            text: referralData?.description,
          },
        ],
        occurrenceDateTime: moment().toISOString(),
      };
      console.log("DEBUG payload: ", payload);
      const response = await createReferral(payload);
      console.log("DEBUG created referral: ", response);
      // await API.createReferral(referral);
      // await loadReferralData();
      // setReferralDialogOpen(false);
      return "";
    } catch (error) {
      return error.message;
    }
  };

  if (error) {
    return (
      <ThemeProvider theme={theme}>
        <Container className={styles.errorContainer}>{error}</Container>
      </ThemeProvider>
    );
  }
  return (
    <div className={styles.documentViewer}>
      {enableServiceDirectory && (
        <FhirServicesSelectionDialog
          open={servicesSelectionDialogOpen}
          handleClose={handleServicesSelectionDialogClosed}
          handleSave={handleReferralSaveLegacy}
        // serviceCategories={serviceCategories}
        // organizationNames={organizationNames}
        />
      )}
      {hasLoadedReferralAddFormData & hasLoadedAdvancedPlanDefinitions && hasLoadedFormSize ? (
        <FhirReferralAddForm
          open={referralAddFormOpen}
          handleClose={handleReferralAddFormClose}
          handleSave={handleReferralSave}
          planDefinition={planDefinition}
          requestIntentVS={requestIntentVS}
          requestCategoryVS={requestCategoryVS}
          referralServicesInternal={referralServicesInternal}
          referralPathCategory={referralPathCategory}
          healthcareServices={healthcareServices}
          submitError={submitError}
          setSubmitError={setSubmitError}
          advancedPlanDefinitionIds={advancedPlanDefinitionIds}
          instantiatesCanonical={instantiatesCanonical}
          setInstantiatesCanonical={setInstantiatesCanonical}
        />
      ) : null}
      <div className={styles.documentViewer}>
        {checkAclValidation({
          acls: [mainAcls.MAIN.REFERRAL.ADD],
        }) &&
          referrals &&
          availableOrganizations &&
          serviceCategories &&
          !showAllReferrals ? (
          <FhirReferralActions>
            {/* {enableServiceDirectory && availableOrganizations ? (
              <FhirReferralActionButton
                text="Search Directory"
                action={handleServicesSelectionDialogClick}
              />
            ) : null} */}
            {hasLoadedReferralAddFormData ? (
              <FhirReferralActionButton
                text="New Referral"
                action={handleReferralAddFormClick}
              />
            ) : null}
          </FhirReferralActions>
        ) : null}
        <FhirReferralsList
          showAllReferrals={showAllReferrals}
          referrals={referrals}
          onReferralClick={handleReferralClick}
        />
      </div>
    </div>
  );
};

export default withRouter(FhirReferralsViewer);
